import React, { useContext, useEffect } from 'react';
import { API, Auth } from 'aws-amplify';
import AppContext from '../../AppContext';
import Q4BizSidebar from '../Q4BizEmbedding/QBizSidebar';

// import styled from "styled-components"

const QuickSightDashboard = ({ dashboardId, dashboardTitle, dashboardType, apiKey, realTime, embedContext, classes, singleSheet = false }) => {
    
  // const [loading, setLoading] = useState(true);
  const { dashboard, setDashboard, showWlsLogo } = useContext(AppContext);

//   const ImgStyled = styled.img`
//   height: 25px;
//   z-index: 9999999;
//   margin: 10px;
//   display: block;
//   top: 0 px;
//   position: relative;
// `


  useEffect(() => {
    if(!!dashboardTitle) {
      document.title = dashboardTitle
    } 
  }, [dashboardTitle])

  useEffect(() => {
    let timer;
    if(realTime && dashboard) {
      timer = setTimeout(() => {
        dashboard.setParameters([{'Name': "refreshParameter", 'Values': Date.now()}]);
        // console.log('asdlfkjslkfdjs')
      }, 5000);

    }
    return () => { clearTimeout(timer) };
  },[realTime, dashboard])

    
  useEffect(() => {
      
    const getDashboardUrl = async () => {
      try {

        let url;
        let headers;
        // let singleSheet = false;
        if(apiKey && dashboardType?.toLowerCase() === 'topic') {
          url = 'get-anonymous-quicksight-q-url?topic_id';
          headers = { 'X-API-Key': apiKey }
        } else if (apiKey) {
          url = 'get-anonymous-quicksight-url?dashboard_id';
          headers = { 'X-API-Key': apiKey }
          // singleSheet = true;
        } else if(dashboardType?.toLowerCase() === 'topic') {
          url='get-quicksight-q-url?topic_id'
          headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
        } else {
          url='get-quicksight-url?dashboard_id'
          headers = { Authorization: await Auth.currentSession().then(data => data.getIdToken().getJwtToken()) }
        }
        try {
          const response = await API.get('APIEndpoint', `/${url}=${dashboardId}&hostname=${window.location.origin}`, {response: true, headers: headers}) 

          if(response?.data?.url) {
            const { embedDashboard, embedGenerativeQnA } = embedContext;
            const frameOptions = {
                url: response.data.url,
                container: document.getElementById(dashboardId),
                height: "100%",
                width: "100%",
                // onChange: ((e,d) => {console.log('frameoptions onChange',e,d)}),
                // onMessage: ((e,d) => {console.log('frameoptions onMessage',e,d)}),

            };
            const contentOptions = {
                parameters: [{'Name': "URL", 'Values': [window.location.host]}],
                toolbarOptions: {
                    export: false,
                    undoRedo: false,
                    reset: false,
                    bookmarks:false
                },
                sheetOptions: {
                //     initialSheetId: '<YOUR_SHEETID>',
                    singleSheet: singleSheet,                        
                //     emitSizeChangedEventOnSheetChange: false,
                },
                attributionOptions: {
                    overlayContent: false,
                },
                // onMessage: async (messageEvent, experienceMetadata) => {
                //     // console.log('messageEvent, experienceMetadata', messageEvent, experienceMetadata)
                //     switch (messageEvent.eventName) {
                //         case 'CONTENT_LOADED': {
                //             console.log("All visuals are loaded. The title of the document:", messageEvent.message.title);
                //             // setLoading(false)
                //             // break;
                //         }
                //         // case 'ERROR_OCCURRED': {
                //         //     console.log("Error occurred while rendering the experience. Error code:", messageEvent.message.errorCode);
                //         //     break;
                //         // }
                //         case 'PARAMETERS_CHANGED': {
                //             console.log("Parameters changed. Changed parameters:", messageEvent);
                //             // setNumberOfParameterChanges(x => x + 1);
                //             // if(messageEvent?.message?.changedParameters[0]?.Name === 'FState') {
                //             //     setResetCity(x => x + 1);
                //             //     // setResetNpi(x => x + 1);
                //             // }
                //             // if(messageEvent?.message?.changedParameters[0]?.Name === 'FCity') {
                //             //     setResetNpi(x => x + 1);
                //             // }
                //             // const params = await dashboard.getParameters()
                //             // setGlobalParameters(params);
                //             break;
                //         }
                //         case 'SELECTED_SHEET_CHANGED': {
                //             console.log("Selected sheet changed. Selected sheet:", messageEvent.message.selectedSheet);
                //             // setActiveSheet(messageEvent?.message?.selectedSheet?.SheetId)
                //             break;
                //         }
                //         // case 'SIZE_CHANGED': {
                //         //     console.log("Size changed. New dimensions:", messageEvent.message);
                //         //     break;
                //         // }
                //         // case 'MODAL_OPENED': {
                //         //     window.scrollTo({
                //         //         top: 0 // iframe top position
                //         //     });
                //         //     break;
                //         // }

                //         default:
                //     }
                // },

            };

            if (dashboardType?.toLowerCase() === 'topic') {
              setDashboard(await embedGenerativeQnA(frameOptions, contentOptions))
            } else {
              setDashboard(await embedDashboard(frameOptions, contentOptions))
            }

            // setLoading(false);

          } else {

          } 
        } catch (err) {
          console.log('err: ', err)
        }

      
      } catch(error) {
        
        if(API.isCancel(error)) {
          // "my message for cancellation"
          console.log(error.message);
          // handle user cancellation logic
        }
          console.log(error)
          // setLoading(false);
          // setFailureMessage('There was an issue loading your dashboard. Please contact your administrator.');
      }
    }

    if (dashboardId && embedContext) {
        setDashboard();
        // setLoading(true);
        getDashboardUrl();
    }

    // return () => API.cancel(response, "my message for cancellation");
    // eslint-disable-next-line 
  },[dashboardId, embedContext, apiKey, dashboardType])

    
  return <div className={classes ? classes : 'flex flex-1 h-full'} >
    <div 
      key={dashboardId}
      id={dashboardId}
      className="dashboardContainer flex w-full relative" //position: "absolute", , maxHeight: "92vh"  
      style={{position: 'relative'}}
    />
    {showWlsLogo &&<div style={{position: 'absolute', bottom: 0, right: 0}}>
      <a href='https://www.westloop.io' alt='Westloop Strategy Home'>
        <img alt='wls' src='/wls_logo.svg' className='logo'/>
      </a>
    </div>}

    {import.meta.env.VITE_SSO === "true" && <Q4BizSidebar/>}

  </div>;
}

export default QuickSightDashboard;